import { Box, Zoom } from '@material-ui/core'
import React, { useEffect, useMemo } from 'react'
import { RiImageLine } from 'react-icons/ri'
import { useToggle } from 'react-use'
import { imageStyle } from './image.style'

export const ImageLoadInit = ({ src, alt, transition: Transition, square, width, height, fallback: Fallback, ...props }) => {
	const [error, onError] = useToggle()

	useEffect(
		() => {
			onError(false)
		},
		// eslint-disable-next-line
		[src]
	)

	const actualWidth = useMemo(() => {
		return square ? height : width
	}, [square, height, width])

	return (
		<Box css={imageStyle} className="img-wrapper" height={height} width={actualWidth} {...props}>
			<div style={{ width: '100%', height: '100%' }}>{!error && <img className={'image-main'} src={src} alt={alt} onError={() => onError(true)} />}</div>
		</Box>
	)
}

ImageLoadInit.defaultProps = {
	transition: Zoom,
	height: 100,
	square: true,
	fallback: RiImageLine,
}
